import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b94db3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("“환경에 찐심인 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-none d-md-block" }),
    /*#__PURE__*/_createTextVNode("원더플 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
    /*#__PURE__*/_createTextVNode("피플을 모집합니다”")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "#함께해요_원더플피플"),
    /*#__PURE__*/_createElementVNode("span", null, "#원더플의_선한영향력")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "#원더플파워 #투명음료페트병"),
    /*#__PURE__*/_createElementVNode("span", null, "#고품질자원화")
  ])
], -1))
const _hoisted_5 = { class: "container-logo-desc" }
const _hoisted_6 = { class: "box-logos" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"container-desc\" data-v-6b94db3d><div class=\"section-title\" data-v-6b94db3d><div data-v-6b94db3d> 지속 가능한 지구 위해, <br class=\"d-block d-md-none\" data-v-6b94db3d> 더욱 강력하게 돌아온 원더플 시즌 3 </div><div data-v-6b94db3d><span class=\"strong\" data-v-6b94db3d>원더플 피플,</span> 우리 함께 실천해요. </div></div><div class=\"section-desc\" data-v-6b94db3d><p data-v-6b94db3d>우리의 일상 생활 속에서 쉽게 사용되고 있는 투명 음료 페트병.</p><p data-v-6b94db3d>다 마시고 버려지는 이 페트병도 소중한 자원이라는 것을 아시나요?</p><p data-v-6b94db3d>소중한 자원으로서 페트병의 가치를 사람들에게 알리고</p><p data-v-6b94db3d>페트병의 순환경제 활성화를 위해 원더플 피플이 다시 모였어요.</p><p data-v-6b94db3d> 원더플 피플이 모은 <span class=\"strong\" data-v-6b94db3d>페트병은 고품질 원료가 되어 </span><br class=\"d-block d-md-none\" data-v-6b94db3d><span class=\"strong\" data-v-6b94db3d>새로운 자원 </span>으로 재탄생할 예정이랍니다. </p><br class=\"d-block d-md-none\" data-v-6b94db3d><p data-v-6b94db3d> 자원 순환을 위한 우리들의 선한 영향력이 더 커질 수 있도록 함께 해요. <br class=\"d-block d-md-none\" data-v-6b94db3d> 원더플 피플! </p></div></div>", 1)


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const logos = [
    {
      link: 'https://www.coca-cola.co.kr',
      class: 'logo-cocacola',
      image: require('./images/logo-cocacola.png')
    },
    {
      link: 'https://www.byn.kr/blackyak',
      class: 'logo-blackyak',
      image: require('./images/logo-blackyak.png')
    },
    {
      link: 'https://company.emart.com/ko/ethic/outline.do',
      class: 'logo-emart',
      image: require('./images/logo-emart.png')
    },
    {
      link: 'https://www.ssg.com',
      class: 'logo-ssg',
      image: require('./images/logo-ssg.png')
    },
    {
      link: 'https://www.gmarket.co.kr',
      class: 'logo-gmark',
      image: require('./images/logo-gmark.png')
    },
    {
      link: 'http://www.auction.co.kr',
      class: 'logo-auction',
      image: require('./images/logo-auction.png')
    },
    {
      link: 'http://www.wwfkorea.or.kr',
      class: 'logo-wwf',
      image: require('./images/logo-wwf.png')
    },
    {
      link: 'https://www.terracycle-kr.com',
      class: 'logo-terracycle',
      image: require('./images/logo-terracycle.png')
    }
  ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(logos, (item, index) => {
            return _createElementVNode("a", {
              key: index,
              href: item.link,
              target: "_blank"
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([item.class]),
                src: item.image
              }, null, 10, _hoisted_8)
            ], 8, _hoisted_7)
          }), 64))
        ]),
        _hoisted_9
      ])
    ])
  ]))
}
}

})